module.exports = __webpack_public_path__ + "static/media/10-Common-traits-of-junk-cars.f9e95618.jpg";